$shm_hitalama_map_presence_cursor $mol_view
	pos /number
	style *
		^
		top <= top_px \
		left <= left_px \
	sub / 
		<= Icon $mol_icon_cursor_default
		<= Name $mol_view
			sub / <= name \afasfs
